import React, { Component } from 'react';

import _ from 'lodash';
import {decode} from 'he'
import {getFromDrupalAPI, getWebsiteContent} from '../fetchJSON.js'

class MinistryTeam extends Component {
  constructor(){
    super();
    this.state = {staffTeam: null,
                  eldership: null,
                  staffAmount: null}
  }

  componentWillMount(){
    var that = this;

    getFromDrupalAPI('staff_and_leadership_api?filters[field_type_value]=ministryworker', function(data){
      that.setState({staffTeam: data})
    });

    getFromDrupalAPI('staff_and_leadership_api?filters[field_type_value]=elder', function(data){
      that.setState({eldership: data})
    });

    getWebsiteContent('MinistryTeam', function(data){
      that.setState({staffAmount: data[0]});
    });

  }

  render() {
    var staffAmountText = {__html: "<p>Loading...</p>"};
    if(this.state.staffTeam)
    {
      var staffTeam = _.map(this.state.staffTeam, (staffMember) => {
        return (
          <div className="row .row-eq-height">
            <div className="col-md-3">
              <div className="item-box">
                <figure>
                  <img className="img-responsive" src={staffMember.image} width="263" height="263" alt="" />
                </figure>
                <div className="item-box-desc">
                  <h4>{staffMember.node_title}</h4>
                  <small className="styleColor">{staffMember.positiontitle}</small>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <p className="ministry-bio">
                {decode(staffMember.bio)}
              </p>
            </div>
          </div>
        )
      });
    }

    if(this.state.eldership)
    {
      var eldership = _.map(this.state.eldership, (elder) => {
        return (
          <div className="row .row-eq-height">
            <div className="col-md-3">
              <div className="item-box">
                <figure>
                  <img className="img-responsive" src={elder.image} width="263" height="263" alt="" />
                </figure>
                <div className="item-box-desc">
                  <h4>{elder.node_title}</h4>
                  <small className="styleColor">Elder</small>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <p className="ministry-bio">
                {decode(elder.bio)}
              </p>
            </div>
          </div>
        )
      });
    }

    if(this.state.staffAmount){
      staffAmountText = {__html: decode(this.state.staffAmount.text)};
    }


    return (
        <section>
          <header id="page-title">
            <div className="container">
              <h1>Ministry Team</h1>
            </div>
          </header>
          <section className="container">

          <h3>Staff Team</h3>
					<p className="lead" dangerouslySetInnerHTML={staffAmountText} />

          {staffTeam}

          {/*Eldership*/}
          <br/>
          <h3>Eldership</h3>
          <p className="lead">
            CRCK believes that God has established local churches to be led by teams of male elders whose qualifications are outlined in 1 Timothy 3 and Titus 1.
            These men, seeking the input of the congregation, are ultimately responsible for the spiritual oversight and governance of the church, protecting her from error and caring for her members.
            The pastors are ultimately accountable to this Leadership Team.
          </p>

          {eldership}

          </section>
        </section>
    );
  }
}

export default MinistryTeam;
